package pt.at.oss.kotlin.manual.validator.unionForm

import pt.at.oss.kotlin.manual.schema.unionForm.UnionFormSchema
import pt.at.oss.kotlin.manual.storage.unionForm.UnionForm
import pt.at.oss.kotlin.manual.validator.common.AddressValidator
import pt.at.oss.kotlin.manual.validator.common.BankAccountInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactInfoValidator
import pt.at.oss.kotlin.manual.validator.common.ContactNameValidator
import pt.at.oss.kotlin.manual.validator.common.CountryOfBusinessValidator
import pt.at.oss.kotlin.manual.validator.common.FixedEstablishmentsValidator
import pt.at.oss.kotlin.manual.validator.common.FixedEstablishmentsValidator.Type
import pt.at.oss.kotlin.manual.validator.common.FreeTextValidator
import pt.at.oss.kotlin.manual.validator.common.IDS_IN_OTHER_MSS_VALIDATOR
import pt.at.oss.kotlin.manual.validator.common.PREV_OR_CURR_OSS_VAT_IDS_VALIDATOR
import pt.at.oss.kotlin.manual.validator.common.SupplyCommencementValidator
import pt.at.oss.kotlin.manual.validator.common.TradingNamesValidator
import pt.at.oss.kotlin.manual.validator.common.WebsitesValidator
import pt.lightweightform.kotlin.type.validator.ValidationError
import pt.lightweightform.kotlin.type.validator.ValidationErrors

/**
 * Created by Pedro Alfaiate on 13/05/2020.
 */
class UnionFormValidator {

    fun validate(model: UnionForm): ValidationErrors {
        val schemaErrors = UnionFormSchema().validate(model)

        if (schemaErrors.errors.isNotEmpty()) {
            return schemaErrors
        } else {
            val extraErrors = mutableListOf<ValidationError>()

            // actsAsElectronicInterface
            // ->required

            // companyName
            // ->required and has max size
            FreeTextValidator.validateFreeText(model.companyName)
                ?.also { extraErrors.add(it) }

            // tradingNames
            TradingNamesValidator.tradingNamesValidate(model.tradingNames.size, model.companyName)
                ?.also { extraErrors.add(it) }
            extraErrors.addAll(model.tradingNames.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

            // countryOfBusiness
            extraErrors.addAll(CountryOfBusinessValidator().validateSequencial(model.countryOfBusiness, model.cobRegion, false, true))

            // address
            extraErrors.addAll(AddressValidator().validateAddressSequencial(model.address))

            // websites
            // ->when present required and has max size
            // ->formatted correctly
            extraErrors.addAll(WebsitesValidator.validateWebsitesSequential(model.websites, false))

            // contactName
            extraErrors.addAll(ContactNameValidator.contactNameSequencialValidate(model.contactName))

            // contactInfo
            extraErrors.addAll(ContactInfoValidator.contactInfoSequencialValidate(model.contactInfo))

            // bankAccountInfo
            extraErrors.addAll(BankAccountInfoValidator.bankAccountInfoSequencialValidate(model.bankAccountInfo, false, true))

            // fixedEstablishments
            val allowedTypes = if (model.notEstablishedInEU) listOf(Type.CONSIGNMENT)
            else listOf(Type.CONSIGNMENT, Type.ESTABLISHMENT)
            extraErrors.addAll(FixedEstablishmentsValidator().validateFixedEstablishmentsSequencial(model.fixedEstablishments, allowedTypes))

            // idsInOtherMSs isoA2 and vat
            model.idsInOtherMSs.forEach { idInOtherMS ->
                extraErrors.addAll(IDS_IN_OTHER_MSS_VALIDATOR.validateVatIdSequencial(idInOtherMS))
            }

            // prevOrCurrOssVatId isoA2 and vat
            model.prevOrCurrOssVatId.forEach { prevOrCurrOssVatId ->
                extraErrors.addAll(PREV_OR_CURR_OSS_VAT_IDS_VALIDATOR.validateVatIdSequencial(prevOrCurrOssVatId))
            }

            // supplyCommencement
            extraErrors.addAll(SupplyCommencementValidator.validateSupplyCommencementSequencial(model.supplyCommencement))

            return ValidationErrors(extraErrors)
        }
    }
}
